export class DialogModelComment {
    constructor(
      public text={string:'',firstTime:false}
    ) {}
  }
  